import { useCallback, useEffect, useRef, useState } from 'react';

export const useSearchOverlayMaxHeightCalculation = (bottomOffset?: number, enabled?: boolean) => {
    const [listMaxHeight, setListMaxHeight] = useState(0);
    const contentWrapperRef = useRef<HTMLDivElement>(null);
    const footerElementRef = useRef<HTMLDivElement>(null);
    const [listScrolledToBottom, setListScrolledToBottom] = useState(true);

    const handleListMaxHeight = useCallback(() => {
        if (contentWrapperRef.current && enabled) {
            const newMaxHeight =
                window.innerHeight -
                contentWrapperRef.current.getBoundingClientRect().top -
                (footerElementRef?.current?.offsetHeight || 0) -
                (bottomOffset || 0);

            setListMaxHeight(newMaxHeight);
        }
    }, [bottomOffset, enabled]);

    const handleListScroll = useCallback(() => {
        if (contentWrapperRef.current) {
            setListScrolledToBottom(
                contentWrapperRef.current.scrollTop + contentWrapperRef.current.offsetHeight <
                    contentWrapperRef.current.scrollHeight,
            );
        }
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleListMaxHeight);

        const handle = contentWrapperRef.current;
        handle?.addEventListener('scroll', handleListScroll);

        return () => {
            handle?.removeEventListener('scroll', handleListScroll);
            window.removeEventListener('resize', handleListMaxHeight);
        };
    }, [handleListMaxHeight, handleListScroll]);

    return {
        contentWrapperRef,
        footerElementRef,
        listMaxHeight,
        listScrolledToBottom,
        recalculateMaxHeight: handleListMaxHeight,
    };
};
